import React, { Component } from 'react';
import './Rsvp.css';
import Header from './Header';
import Guest from './Guest'
import Login from './Login'
import arrow from './img/arrow.png';
import cookie from 'react-cookie';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CircularProgress from 'material-ui/CircularProgress';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';

class Rsvp extends Component {

  lookupGuest = (id) => {
    const url = `https://8ddxuiivkd.execute-api.us-east-1.amazonaws.com/production/guest?id=${id}`
    this.getCORS(url, 'GET', null, this.guestSuccess);
  }

  getCORS = (url, method, args, success) => {
      var xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.onload = success;
      xhr.send(args);
      return xhr;
  }

  guestSuccess = (response) => {
      var r = response.currentTarget.response || response.target.responseText;
      const guest = JSON.parse(r);
      if (!guest) {
        cookie.save('id', "", { path: '/' });
        window.location = "/rsvp";
        return;
      }
      this.setState({guest: guest.guest});
      this.setState({household: guest.household});
  };

  componentWillMount() {
    const idRegex = /#id=(.*)/;
    const hash = this.props.location.hash;
    if (hash) {
      const match = idRegex.exec(hash);
      if (match && match.length > 0) {
        cookie.save('id', match[1], { path: '/', maxAge: 2147483647 });
        window.location.hash = "";
      }
    }
    this.state =  { userId: cookie.load('id') };
    if (this.state.userId) {
      this.lookupGuest(this.state.userId);
    }
  }

  render() {
    const toolbarStyle = {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    }
    const toolbarGroupStyle = {
        float       : 'none',
        marginLeft  : 'auto',
        marginRight : 'auto',
        textAlign   : 'center',
    };

    var caption = "Respondez, s'il vous plait"

    var household = this.state.household ?
      (this.state.household.map(function(person, i) {
        return <Guest key={i} guest={person}/>
      })) : [];

    return (
      <div className="Rsvp">
        <Header caption={caption} />
        <MuiThemeProvider>
          <Toolbar style={toolbarStyle}>
            <ToolbarGroup style={toolbarGroupStyle}>
              <a className="plain-link back-link" href="/">&lt; Back to Site</a>
            </ToolbarGroup>
          </Toolbar>
        </MuiThemeProvider>
        <div className="rsvp-section row middle-xs center-xs">
            {this.state.userId ? (
              <div className="col-lg-6 col-xs-10">
                <h2>RSVP</h2>
                <img src={arrow} alt="Alex and Hana" className="arrow"/>
                <p>Let us know if you and yours will be attending.</p>
                <div className="emphasis">👀Heads up 👀</div>
                <p className="subnotes">Please RSVP by April 16, 2017.</p>
              </div>
            ):
              <div className="col-lg-6 col-xs-10">
                <h2>Hello</h2>
                <img src={arrow} alt="Alex and Hana" className="arrow"/>
                <p>Welcome, friend!</p>
                <p>To access your RSVP form for Alex and Hana&#39;s <span className="emphasis">special day</span>, please enter your email below.</p>
              </div>
            }
        </div>
        <div className="rsvp-section row middle-xs center-xs">
          <div className="col-lg-3 col-xs-10">
            {this.state.userId ? (
              <div>
                {this.state.guest ?
                  <Guest guest={this.state.guest}/>
                :
                  <MuiThemeProvider>
                    <CircularProgress />
                  </MuiThemeProvider>
                }
                {household}
              </div>
            ):
              <div>
                <Login />
              </div>
            }
          </div>
        </div>
        <div className="section row middle-xs center-xs">
          <div className="col-lg-6 col-xs-10">
            <div>Questions? 💌 us at <a href="mailto:us@alexandhana.com">us@alexandhana.com</a>.</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Rsvp;



// WEBPACK FOOTER //
// ./src/Rsvp.js